/* eslint-disable no-unused-expressions */
module.exports = [
  {
    id: 1,
    templete: ``,
  },
  {
    id: 2,
    templete: ``,
  },
  {
    id: 3,
    name: "Layout para generar componentes v4",
    templete: `<!DOCTYPE html>
    <html itemscope itemtype="http://schema.org/WebPage">
      <head lang="es" xml:lang="es">
        <title>Compliance AMX</title>
        <meta charset="utf-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no">
        <!--metatags-->
        <meta name="Description" content="undefined">
        <meta name="Keywords" content="undefined">
        <!-- apple metatags-->
        <meta name="apple-mobile-web-app-capable" content="yes">
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent">
        <!-- iconos-->
        <link rel="shorcut icon" href="css/img/favicon.ico">
        <link rel="shorcut icon" href="css/img/favicon.png">
        <link rel="apple-touch-icon" href="css/img/icon-touch.png">
        <link rel="apple-touch-icon" sizes="72x72" href="css/img/icon-touch-72.png">
        <link rel="apple-touch-icon" sizes="114x114" href="css/img/icon-touch-114.png">
        <link rel="apple-touch-icon" sizes="144x144" href="css/img/icon-touch-144.png">
        <!-- preloaders-->
        <link rel="preload" href="/layout/css/font-claro.css" as="style">
        <link rel="preload" href="https://www.complianceamx.com/css/styles.css" as="style">
        <link rel="preload" href="https://www.complianceamx.com/css/style-dev.css" as="style">
        <!-- styles-->
        <link rel="stylesheet" href="/layout/css/font-claro.css" type="text/css">
        <link rel="stylesheet" href="https://www.complianceamx.com/css/styles.css" type="text/css">
        <link rel="stylesheet" href="https://www.complianceamx.com/css/style-dev.css" type="text/css">
        <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.css" as="style">
        <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.min.js"></script>
        <script src="https://www.complianceamx.com/script/core.js"></script>
        <script src="https://www.complianceamx.com/script/homeSlider.js"></script>
      </head>
      <body>
        <header>
          <div class="headerCont">
            <nav><a href="./" class="logo"><img src="/layout/img/logo-compliance.svg" width="117" height="100" alt="Programa integridad y cumplimiento Compromiso de todos"></a>
              <ul>
                <li><a href="#">Como Operamos</a>
                  <div class="subMenu">
                    <ul>
                      <li><a href="comite.html">Comité</a></li>
                      <li><a href="valores.html">Valores</a></li>
                    </ul>
                  </div>
                </li>
                <li><a href="documentos-cumplimiento.html">Documentos de Cumplimiento</a>
                  <div class="subMenu">
                    <ul>
                      <li><a href="documentos-cumplimiento-documentos.html">Documentos</a></li>
                      <li><a href="formularios-cumplimiento.html">Formularios de Cumplimiento</a></li>
                    </ul>
                  </div>
                </li>
                <li><a href="capacitate-empleo.html">Capacitate para el Empleo</a></li>
                <li><a href="comunicacion.html">Comunicación</a></li>
              </ul>
            </nav>
            <div class="hUserActions">
              <div class="openSearch"><i class="ico-search"></i></div>
              <div class="userOptions">
                <div class="iconUser"><i class="ico-user"></i></div><span>Hola José Luis</span>
              </div>
            </div>
          </div>
        </header>
        <main class="wrapper wfix dynamic-elements-content">
          <!-- <div class="breadcrumbs">
            <div class="container">
              <ul>
                <li><a href="#">Home</a></li>
                <li><a href="#">Como Operamos</a></li>
                <li class="current">Comité</li>
              </ul>
            </div>
          </div> -->
          <section class="modMainCO diagonalNextSect sct-banner-img-rigth">
            <div class="container">
              <div class="contFlexCO">
                <div class="mainInfCO">
                  <h1 class="sct-banner-img-rigth-title">Lorem Ipsum is simply dummy text of the printing</h1>
                  <h3 class="sct-banner-img-rigth-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since.</h3>
                  <a href="#" class="btn sct-banner-img-rigth-button">Ver Estatus</a>
                </div>
                <picture class="mainImgCO">
                  <img class="sct-banner-img-rigth-img" src="https://via.placeholder.com/480x500.jpg" alt="Inicio de Sesion">
                </picture>
              </div>
            </div>
          </section>
          <section class="modMainCO sct-description-img-rigth">
            <div class="container">
              <div class="contFlexCO">
                <div class="mainInfCO">
                  <h1 class="sct-description-img-rigth-title">Oficialia de Cumplimiento de América Móvil</h1>
                  <div class="mainInfCODesc sct-description-img-rigth-des">
                    <p>La implementación y desarrollo del PIC corresponde a la Oficialía de Cumplimiento de América Móvil con el apoyo de las oficialías de cumplimiento de nuestras subsidiarias, con el objetivo de asegurar el funcionamiento íntegro de nuestra empresa  y sus colaboradores.</p>
                  </div>
                  <a href="#" class="btn sct-description-img-rigth-button">Ver Estatus</a>
                </div>
                <picture class="mainImgCO">
                  <img class="sct-description-img-rigth-img" src="https://via.placeholder.com/480x500.jpg" width="480" height="500" alt="Inicio de Sesion">
                </picture>
              </div>
              <div class="contWideCo sct-description-img-rigth-des-alt">

              </div>
            </div>
          </section>
          <section class="modJD diagonalSect noDiagBottom sct-floating-cards">
            <div class="diagTop"></div>
            <div class="container">
              <h2 class="tituloJD sct-floating-cards-title">Junta Directiva</h2>
              <div class="contCardsJD sct-floating-cards-container">
                <div class="cardJD sct-floating-cards-item">
                  <div class="cardJDCont">
                    <picture class="cardJDImg">
                      <img class="sct-floating-cards-item-img" src="https://via.placeholder.com/140x140.jpg" width="140" height="140" alt="Inicio de Sesion">
                    </picture>
                    <div class="cardJDInf">
                      <h3 class="sct-floating-cards-item-title">Lorem Ipsum is simply dummy text</h3>
                      <p class="sct-floating-cards-item-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since.</p>
                    </div>
                  </div>
                </div>
                <div class="cardJD sct-floating-cards-item">
                  <div class="cardJDCont">
                    <picture class="cardJDImg">
                      <img class="sct-floating-cards-item-img" src="https://via.placeholder.com/140x140.jpg" width="140" height="140" alt="Inicio de Sesion">
                    </picture>
                    <div class="cardJDInf">
                      <h3 class="sct-floating-cards-item-title">Lorem Ipsum is simply dummy text</h3>
                      <p class="sct-floating-cards-item-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since.</p>
                    </div>
                  </div>
                </div>
                <div class="cardJD sct-floating-cards-item">
                  <div class="cardJDCont">
                    <picture class="cardJDImg">
                      <img class="sct-floating-cards-item-img" src="https://via.placeholder.com/140x140.jpg" width="140" height="140" alt="Inicio de Sesion">
                    </picture>
                    <div class="cardJDInf">
                      <h3 class="sct-floating-cards-item-title">Lorem Ipsum is simply dummy text</h3>
                      <p class="sct-floating-cards-item-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since.</p>
                    </div>
                  </div>
                </div>
                <div class="cardJD sct-floating-cards-item">
                  <div class="cardJDCont">
                    <picture class="cardJDImg">
                      <img class="sct-floating-cards-item-img" src="https://via.placeholder.com/140x140.jpg" width="140" height="140" alt="Inicio de Sesion">
                    </picture>
                    <div class="cardJDInf">
                      <h3 class="sct-floating-cards-item-title">Lorem Ipsum is simply dummy text</h3>
                      <p class="sct-floating-cards-item-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since.</p>
                    </div>
                  </div>
                </div>
                <div class="cardJD sct-floating-cards-item">
                  <div class="cardJDCont">
                    <picture class="cardJDImg">
                      <img class="sct-floating-cards-item-img" src="https://via.placeholder.com/140x140.jpg" width="140" height="140" alt="Inicio de Sesion">
                    </picture>
                    <div class="cardJDInf">
                      <h3 class="sct-floating-cards-item-title">Lorem Ipsum is simply dummy text</h3>
                      <p class="sct-floating-cards-item-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since.</p>
                    </div>
                  </div>
                </div>
                <div class="cardJD sct-floating-cards-item">
                  <div class="cardJDCont">
                    <picture class="cardJDImg">
                      <img class="sct-floating-cards-item-img" src="https://via.placeholder.com/140x140.jpg" width="140" height="140" alt="Inicio de Sesion">
                    </picture>
                    <div class="cardJDInf">
                      <h3 class="sct-floating-cards-item-title">Lorem Ipsum is simply dummy text</h3>
                      <p class="sct-floating-cards-item-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
    
          <!-- BANNER repetido -->
          <!--<section class="bannerTextImg">
            <div class="container">
              <div class="bannerTextImgLeft">
                <h1>Documentos del Programa de Integridad y Cumplimiento</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
              </div>
            </div>
            <div class="bannerTextImgRight">
              <picture>
                <source type="image/webp" srcset="img/img-banner-documentos.webp">
                <source type="image/png" srcset="img/img-banner-documentos.png"><img src="img/img-banner-documentos.png" width="786" height="686" alt="Documentos del Programa de Integridad y Cumplimiento">
              </picture>
            </div>
          </section> -->
          <!-- Cards de documentos-->
          <section class="iconBoxGrid diagonalSect noDiagBottom sct-cards-doc">
            <div class="diagTop"></div>
            <div class="container sct-cards-doc-container">
              <div class="iconBoxWrap sct-cards-doc-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-cards-doc-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-cards-doc-item-title">Datos Personales</h3>
                  <p class="sct-cards-doc-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a class="btnTransGrad sct-cards-doc-item-button-link" href="_blank"><span class="sct-cards-doc-item-button-txt">Ir a Documentación</span></a>
                </div>
              </div>
              <div class="iconBoxWrap sct-cards-doc-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-cards-doc-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-cards-doc-item-title">Datos Personales</h3>
                  <p class="sct-cards-doc-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a class="btnTransGrad sct-cards-doc-item-button-link"><span class="sct-cards-doc-item-button-txt">Ir a Documentación</span></a>
                </div>
              </div>
              <div class="iconBoxWrap sct-cards-doc-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-cards-doc-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-cards-doc-item-title">Datos Personales</h3>
                  <p class="sct-cards-doc-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a class="btnTransGrad sct-cards-doc-item-button-link"><span class="sct-cards-doc-item-button-txt">Ir a Documentación</span></a>
                </div>
              </div>
              <div class="iconBoxWrap sct-cards-doc-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-cards-doc-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-cards-doc-item-title">Datos Personales</h3>
                  <p class="sct-cards-doc-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a class="btnTransGrad sct-cards-doc-item-button-link"><span class="sct-cards-doc-item-button-txt">Ir a Documentación</span></a>
                </div>
              </div>
              <div class="iconBoxWrap sct-cards-doc-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-cards-doc-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-cards-doc-item-title">Datos Personales</h3>
                  <p class="sct-cards-doc-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a class="btnTransGrad sct-cards-doc-item-button-link"><span class="sct-cards-doc-item-button-txt">Ir a Documentación</span></a>
                </div>
              </div>
              <div class="iconBoxWrap sct-cards-doc-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-cards-doc-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-cards-doc-item-title">Datos Personales</h3>
                  <p class="sct-cards-doc-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a class="btnTransGrad sct-cards-doc-item-button-link"><span class="sct-cards-doc-item-button-txt">Ir a Documentación</span></a>
                </div>
              </div>
            </div>
          </section>
    
          <section class="modBannerFC diagonalNextSect sct-banner-img-left">
            <div class="container">
              <div class="contFlexFC">
                <picture class="bannerFCImg">
                  <img class="sct-banner-img-left-img" src="https://via.placeholder.com/450x440.jpg" alt="Inicio de Sesion">
                </picture>
                <div class="bannerFCInf">
                  <div class="bannerFCInfCont">
                    <h1 class="sct-banner-img-left-title">Formularios de Cumplimiento</h1>
                    <h3 class="sct-banner-img-left-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</h3>
                    <a href="#" class="btn sct-banner-img-left-button">Ver Estatus</a>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- Componente de procesos-->
          <section class="iconBoxGrid diagonalSect sct-processes">
            <div class="diagTop"></div>
            <div class="container">
              <h2 class="tituloBoxWrap">Formularios y Procesos</h2>
            </div>
            <div class="container sct-processes-container">
              <div class="iconBoxWrap sct-processes-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-processes-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-processes-item-title">Datos Personales</h3>
                  <p class="sct-processes-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a href="#" class="btnTransGrad sct-processes-item-button-link"><span class="sct-processes-item-button-txt">Ir a Documentación</span></a>
                  <a href="#" class="btnTransGrad sct-processes-item-button-report"><span class="sct-processes-item-button-txt">Reporte de seguimiento</span></a>
                  <a href="#" class="btnTransGrad btnStatus sct-processes-item-button-status"><span class="sct-processes-item-button-txt">Ver Estatus</span></a>
                </div>
              </div>
              <div class="iconBoxWrap sct-processes-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-processes-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-processes-item-title">Datos Personales</h3>
                  <p class="sct-processes-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a href="#" class="btnTransGrad sct-processes-item-button-link"><span class="sct-processes-item-button-txt">Ir a Documentación</span></a>
                  <a href="#" class="btnTransGrad sct-processes-item-button-report"><span class="sct-processes-item-button-txt">Reporte de seguimiento</span></a>
                  <a href="#" class="btnTransGrad btnStatus sct-processes-item-button-status"><span class="sct-processes-item-button-txt">Ver Estatus</span></a>
                </div>
              </div>
              <div class="iconBoxWrap sct-processes-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-processes-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-processes-item-title">Datos Personales</h3>
                  <p class="sct-processes-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a href="#" class="btnTransGrad sct-processes-item-button-link"><span class="sct-processes-item-button-txt">Ir a Documentación</span></a>
                  <a href="#" class="btnTransGrad sct-processes-item-button-report"><span class="sct-processes-item-button-txt">Reporte de seguimiento</span></a>
                  <a href="#" class="btnTransGrad btnStatus sct-processes-item-button-status"><span class="sct-processes-item-button-txt">Ver Estatus</span></a>
                </div>
              </div>
              <div class="iconBoxWrap sct-processes-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-processes-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-processes-item-title">Datos Personales</h3>
                  <p class="sct-processes-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a href="#" class="btnTransGrad sct-processes-item-button-link"><span class="sct-processes-item-button-txt">Ir a Documentación</span></a>
                  <a href="#" class="btnTransGrad sct-processes-item-button-report"><span class="sct-processes-item-button-txt">Reporte de seguimiento</span></a>
                  <a href="#" class="btnTransGrad btnStatus sct-processes-item-button-status"><span class="sct-processes-item-button-txt">Ver Estatus</span></a>
                </div>
              </div>
              <div class="iconBoxWrap sct-processes-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-processes-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-processes-item-title">Datos Personales</h3>
                  <p class="sct-processes-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a href="#" class="btnTransGrad sct-processes-item-button-link"><span class="sct-processes-item-button-txt">Ir a Documentación</span></a>
                  <a href="#" class="btnTransGrad sct-processes-item-button-report"><span class="sct-processes-item-button-txt">Reporte de seguimiento</span></a>
                  <a href="#" class="btnTransGrad btnStatus sct-processes-item-button-status"><span class="sct-processes-item-button-txt">Ver Estatus</span></a>
                </div>
              </div>
              <div class="iconBoxWrap sct-processes-item">
                <div class="iconBox">
                  <div class="iconBoxImg">
                    <picture>
                      <img class="sct-processes-item-img" src="img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                    </picture>
                  </div>
                  <h3 class="sct-processes-item-title">Datos Personales</h3>
                  <p class="sct-processes-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                  <a href="#" class="btnTransGrad sct-processes-item-button-link"><span class="sct-processes-item-button-txt">Ir a Documentación</span></a>
                  <a href="#" class="btnTransGrad sct-processes-item-button-report"><span class="sct-processes-item-button-txt">Reporte de seguimiento</span></a>
                  <a href="#" class="btnTransGrad btnStatus sct-processes-item-button-status"><span class="sct-processes-item-button-txt">Ver Estatus</span></a>
                </div>
              </div>
              
            </div>
            <div class="diagBottom"></div>
          </section>
    
          <!-- Banner repetido-->
          <!-- <section class="modBannerEP">
            <div class="container">
              <div class="contFlexEP">
                <div class="bannerEPInf">
                  <div class="bannerEPInfCont">
                    <h2>Estatus de Procesos</h2>
                    <h3>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam</h3><a href="#" class="btn">Ver Estatus</a>
                  </div>
                </div>
                <picture class="bannerEPImg">
                  <source type="image/webp" srcset="https://via.placeholder.com/430x300.webp">
                  <source type="image/jpg" srcset="https://via.placeholder.com/430x300.jpg"><img src="https://via.placeholder.com/430x300.jpg" width="430" height="300" alt="Inicio de Sesion">
                </picture>
              </div>
            </div>
          </section> -->
    
          <section class="bannerImgBg sct-main-banner">
            <div class="overlay"></div>
            <div class="imgBG">
              <picture>
                <img class="sct-main-banner-img" src="img/img-banner-home.png" width="1440" height="700" alt="Lorem Ipsum is simply dummy text">
              </picture>
            </div>
            <div class="container">
              <div class="bannerTextImgLeft">
                <h1 class="sct-main-banner-title" >Lorem Ipsum is simply dummy text</h1>
                <p class="sct-main-banner-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard.</p>
                <a href="#" class="btnWhite sct-main-banner-btn" style="margin-top: 32px">Conoce más</a>
              </div>
            </div>
          </section>
    
          <section class="homeColGrid diagonalSect sct-3blocks">
            <div class="diagTop"></div>
            <div class="container sct-3blocks-container">
              <div class="homeColBox sct-3blocks-item">
                <div class="homeColImg">
                  <picture>
                    <img class="sct-3blocks-item-img" src="img/img-home-grid.png" width="123" height="100" alt="Debida Diligencia">
                  </picture>
                </div>
                <h3 class="sct-3blocks-item-title">Debida Diligencia</h3>
                <p class="sct-3blocks-item-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                <a href="#" class="btnIcon right sct-3blocks-item-link"><i class="ico-arrow-right-circle"></i><span class="sct-3blocks-item-btntxt">Conoce más</span></a>
              </div>
              <div class="homeColBox sct-3blocks-item">
                <div class="homeColImg">
                  <picture>
                    <img class="sct-3blocks-item-img" src="img/img-home-grid.png" width="123" height="100" alt="Debida Diligencia">
                  </picture>
                </div>
                <h3 class="sct-3blocks-item-title">Portal de Denuncia</h3>
                <p class="sct-3blocks-item-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                <a href="#" class="btnIcon right sct-3blocks-item-link"><i class="ico-arrow-right-circle"></i><span class="sct-3blocks-item-btntxt">Conoce más</span></a>
              </div>
              <div class="homeColBox sct-3blocks-item">
                <div class="homeColImg">
                  <picture>
                    <img class="sct-3blocks-item-img" src="img/img-home-grid.png" width="123" height="100" alt="Debida Diligencia">
                  </picture>
                </div>
                <h3 class="sct-3blocks-item-title">Politicas</h3>
                <p class="sct-3blocks-item-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                <a href="#" class="btnIcon right sct-3blocks-item-link"><i class="ico-arrow-right-circle"></i><span class="sct-3blocks-item-btntxt">Conoce más</span></a>
              </div>
            </div>
            <div class="diagBottom"></div>
          </section>
          <!-- Componente documentos recientes 2da Fase -->

          <section class="homeDocsSlider sct-ultimos-documentos">
            <div class="container">
              <div class="homeDocsSliderIntro">
                <h2 class="sct-ultimos-documentos-title">Ultimos Documentos Agregados</h2>
                <p class="sct-ultimos-documentos-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
              </div>
              <div class="homeDocsSliderCarousel">
                <div class="homeDocSld" style="height: auto;">
                  <div class="homeDocSldBox" style="height: auto;">
                    <div class="homeDocSldBoxpTitle">
                      <div class="homeDocSldBoxImg">
                        <picture>
                          <img src="/layout/img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                        </picture>
                      </div>
                      <h3>Manual Informativo<span>Publicado el 10 de abril de 2021</span></h3>
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                    <div class="homeDocSldBoxBtn"><a href="#" class="btnIcon right"><i class="ico-download"></i><span>Descargar</span></a></div>
                  </div>
                </div>
                <div class="homeDocSld" style="height: auto;">
                  <div class="homeDocSldBox" style="height: auto;">
                    <div class="homeDocSldBoxpTitle">
                      <div class="homeDocSldBoxImg">
                        <picture>
                          <img src="/layout/img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                        </picture>
                      </div>
                      <h3>Manual Informativo<span>Publicado el 10 de abril de 2021</span></h3>
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                    <div class="homeDocSldBoxBtn"><a href="#" class="btnIcon right"><i class="ico-download"></i><span>Descargar</span></a></div>
                  </div>
                </div>
                <div class="homeDocSld" style="height: auto;">
                  <div class="homeDocSldBox" style="height: auto;">
                    <div class="homeDocSldBoxpTitle">
                      <div class="homeDocSldBoxImg">
                        <picture>
                          <img src="/layout/img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                        </picture>
                      </div>
                      <h3>Manual Informativo<span>Publicado el 10 de abril de 2021</span></h3>
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                    <div class="homeDocSldBoxBtn"><a href="#" class="btnIcon right"><i class="ico-download"></i><span>Descargar</span></a></div>
                  </div>
                </div>
                <div class="homeDocSld" style="height: auto;">
                  <div class="homeDocSldBox" style="height: auto;">
                    <div class="homeDocSldBoxpTitle">
                      <div class="homeDocSldBoxImg">
                        <picture>
                          <img src="/layout/img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                        </picture>
                      </div>
                      <h3>Manual Informativo<span>Publicado el 10 de abril de 2021</span></h3>
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                    <div class="homeDocSldBoxBtn"><a href="#" class="btnIcon right"><i class="ico-download"></i><span>Descargar</span></a></div>
                  </div>
                </div>
                <div class="homeDocSld" style="height: auto;">
                  <div class="homeDocSldBox" style="height: auto;">
                    <div class="homeDocSldBoxpTitle">
                      <div class="homeDocSldBoxImg">
                        <picture>
                          <img src="/layout/img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                        </picture>
                      </div>
                      <h3>Manual Informativo<span>Publicado el 10 de abril de 2021</span></h3>
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                    <div class="homeDocSldBoxBtn"><a href="#" class="btnIcon right"><i class="ico-download"></i><span>Descargar</span></a></div>
                  </div>
                </div>
                <div class="homeDocSld">
                  <div class="homeDocSldBox">
                    <div class="homeDocSldBoxpTitle">
                      <div class="homeDocSldBoxImg">
                        <picture>
                          <img src="/layout/img/img-icon-sample.png" width="50" height="50" alt="Ejemplo">
                        </picture>
                      </div>
                      <h3>Manual Informativo<span>Publicado el 10 de abril de 2021</span></h3>
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
                    <div class="homeDocSldBoxBtn"><a href="#" class="btnIcon right"><i class="ico-download"></i><span>Descargar</span></a></div>
                  </div>
                </div>
              </div>
              <div class="homeDocsSliderBtn"><a href="Documentos" class="btn">Ver todos</a></div>
            </div>
          </section>
          <section class="homeEthical sct-banner-code-ethics">
            <div class="overlay"></div>
            <div class="imgBG">
              <picture>
                <img class="sct-banner-code-ethics-img" src="https://via.placeholder.com/1440x500.jpg" width="1440" height="500" alt="Código de Etica">
              </picture>
            </div>
            <div class="container">
              <div class="homeEthicalCont">
                <h2 class="sct-banner-code-ethics-title">Código de Etica</h2>
                <p class="sct-banner-code-ethics-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic.</p>
                <a href="#" class="btnWhite sct-banner-code-ethics-btn">Conoce más</a>
              </div>
            </div>
          </section>
    
    
          <section class="homeSites sliders-logos">
            <div class="container">
              <h2 class="sliders-logos-title">Sitios de Interes</h2>
              <div class="homeSitesSlider sliders-logos-container" style="height: 80px">
                <div class="homeSiteSlide sliders-logos-item">
                  <a href="#" target="_blank" class="sliders-logos-item-link">
                    <picture>
                      <img class="sliders-logos-item-img" src="img/logo-trace.jpg" width="auto" height="74" alt="Trece">
                    </picture>
                  </a>
                </div>
                <div class="homeSiteSlide sliders-logos-item">
                  <a href="#" target="_blank" class=" sliders-logos-item-link">
                    <picture>
                      <img class="sliders-logos-item-img" src="img/logo-asume.jpg" width="91" height="74" alt="Asume">
                    </picture>
                  </a>
                </div>
                <div class="homeSiteSlide sliders-logos-item">
                  <a href="#" target="_blank" class="sliders-logos-item-link">
                    <picture>
                      <img class="sliders-logos-item-img" src="img/logo-empleo.jpg" width="314" height="67"
                        alt="Capacitate para el empleo">
                    </picture>
                  </a>
                </div>
                <div class="homeSiteSlide sliders-logos-item">
                  <a href="#" target="_blank" class="sliders-logos-item-link">
                    <picture>
                      <img class="sliders-logos-item-img" src="img/logo-amx.jpg" width="210" height="60" alt="América Móvil">
                    </picture>
                  </a>
                </div>
              </div>
            </div>
          </section>
    
          <section class="modTabsV diagonalSect noDiagBottom sct-bullets">
            <div class="diagTop"></div>
            <div class="compTabs">
              <div class="container">
                <div class="flexTabsV sct-bullets-indicators">
                  <input id="page" type="radio" name="cpagination" class="pagRadio">
                  <!-- <input id="page2" type="radio" name="cpagination" class="pagRadio2">
                  <input id="page3" type="radio" name="cpagination" class="pagRadio3">
                  <input id="page4" type="radio" name="cpagination" class="pagRadio4">
                  <input id="page5" type="radio" name="cpagination" class="pagRadio5">
                  <input id="page6" type="radio" name="cpagination" class="pagRadio6">
                  <input id="page7" type="radio" name="cpagination" class="pagRadio7">
                  <input id="page8" type="radio" name="cpagination" class="pagRadio8">
                  <input id="page9" type="radio" name="cpagination" class="pagRadio9"> -->
                  <div class="contTabs sct-bullets-content">
                    <div class="compPage cPage sct-bullets-item">
                      <div class="contMainVP">
                        <picture class="mainVPImg">
                          <img class="sct-bullets-item-img" src="https://via.placeholder.com/120x120.png" width="120" height="120" alt="Inicio de Sesion">
                        </picture>
                        <div class="mainVPTxt">
                          <div class="mainVPTitle"> 
                            <h2 class="sct-bullets-item-title">Honestidad</h2>
                            <!--<p class="fakeTitle sct-bullets-item-title-fake">Honestidad</p>-->
                          </div>
                          <div class="mainVPInf sct-bullets-item-description">
                            <p>Estamos comprometidos con los más altos estándares éticos. Debemos actuar con honestidad e integridad en todo momento. </p>
                            <p>Conducirnos con integridad genera seguridad y confianza entre nosotros mismos y en las relaciones con nuestros clientes, proveedores y otros socios comerciales. También fomenta el respeto a nuestra organización y nos permite ser exitosos. </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="compPage cPage2 sct-bullets-item">
                      <div class="contMainVP">
                        <picture class="mainVPImg">
                          <source type="image/webp" srcset="https://via.placeholder.com/120x120.webp">
                          <source type="image/png" srcset="https://via.placeholder.com/120x120.png"><img src="https://via.placeholder.com/120x120.png" width="120" height="120" alt="Inicio de Sesion">
                        </picture>
                        <div class="mainVPTxt">
                          <div class="mainVPTitle"> 
                            <h2>Desarrollo Humano</h2>
                            <p class="fakeTitle">Desarrollo</p>
                          </div>
                          <div class="mainVPInf">
                            <p>Estamos comprometidos con los más altos estándares éticos. Debemos actuar con honestidad e integridad en todo momento. </p>
                            <p>Conducirnos con integridad genera seguridad y confianza entre nosotros mismos y en las relaciones con nuestros clientes, proveedores y otros socios comerciales. También fomenta el respeto a nuestra organización y nos permite ser exitosos. </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="compPage cPage3 sct-bullets-item">
                      <div class="contMainVP">
                        <picture class="mainVPImg">
                          <source type="image/webp" srcset="https://via.placeholder.com/120x120.webp">
                          <source type="image/png" srcset="https://via.placeholder.com/120x120.png"><img src="https://via.placeholder.com/120x120.png" width="120" height="120" alt="Inicio de Sesion">
                        </picture>
                        <div class="mainVPTxt">
                          <div class="mainVPTitle"> 
                            <h2>Respeto</h2>
                            <p class="fakeTitle">Respeto</p>
                          </div>
                          <div class="mainVPInf">
                            <p>Estamos comprometidos con los más altos estándares éticos. Debemos actuar con honestidad e integridad en todo momento. </p>
                            <p>Conducirnos con integridad genera seguridad y confianza entre nosotros mismos y en las relaciones con nuestros clientes, proveedores y otros socios comerciales. También fomenta el respeto a nuestra organización y nos permite ser exitosos. </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="compPage cPage4 sct-bullets-item">
                      <div class="contMainVP">
                        <picture class="mainVPImg">
                          <source type="image/webp" srcset="https://via.placeholder.com/120x120.webp">
                          <source type="image/png" srcset="https://via.placeholder.com/120x120.png"><img src="https://via.placeholder.com/120x120.png" width="120" height="120" alt="Inicio de Sesion">
                        </picture>
                        <div class="mainVPTxt">
                          <div class="mainVPTitle"> 
                            <h2>Creatividad Empresarial</h2>
                            <p class="fakeTitle">Creatividad</p>
                          </div>
                          <div class="mainVPInf">
                            <p>Estamos comprometidos con los más altos estándares éticos. Debemos actuar con honestidad e integridad en todo momento. </p>
                            <p>Conducirnos con integridad genera seguridad y confianza entre nosotros mismos y en las relaciones con nuestros clientes, proveedores y otros socios comerciales. También fomenta el respeto a nuestra organización y nos permite ser exitosos. </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="compPage cPage5 sct-bullets-item">
                      <div class="contMainVP">
                        <picture class="mainVPImg">
                          <source type="image/webp" srcset="https://via.placeholder.com/120x120.webp">
                          <source type="image/png" srcset="https://via.placeholder.com/120x120.png"><img src="https://via.placeholder.com/120x120.png" width="120" height="120" alt="Inicio de Sesion">
                        </picture>
                        <div class="mainVPTxt">
                          <div class="mainVPTitle"> 
                            <h2>Productividad</h2>
                            <p class="fakeTitle">Productividad</p>
                          </div>
                          <div class="mainVPInf">
                            <p>Estamos comprometidos con los más altos estándares éticos. Debemos actuar con honestidad e integridad en todo momento. </p>
                            <p>Conducirnos con integridad genera seguridad y confianza entre nosotros mismos y en las relaciones con nuestros clientes, proveedores y otros socios comerciales. También fomenta el respeto a nuestra organización y nos permite ser exitosos. </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="compPage cPage6 sct-bullets-item">
                      <div class="contMainVP">
                        <picture class="mainVPImg">
                          <source type="image/webp" srcset="https://via.placeholder.com/120x120.webp">
                          <source type="image/png" srcset="https://via.placeholder.com/120x120.png"><img src="https://via.placeholder.com/120x120.png" width="120" height="120" alt="Inicio de Sesion">
                        </picture>
                        <div class="mainVPTxt">
                          <div class="mainVPTitle"> 
                            <h2>Optimismo y Actitud Positiva.</h2>
                            <p class="fakeTitle">Optimismo</p>
                          </div>
                          <div class="mainVPInf">
                            <p>Estamos comprometidos con los más altos estándares éticos. Debemos actuar con honestidad e integridad en todo momento. </p>
                            <p>Conducirnos con integridad genera seguridad y confianza entre nosotros mismos y en las relaciones con nuestros clientes, proveedores y otros socios comerciales. También fomenta el respeto a nuestra organización y nos permite ser exitosos. </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="compPage cPage7 sct-bullets-item">
                      <div class="contMainVP">
                        <picture class="mainVPImg">
                          <source type="image/webp" srcset="https://via.placeholder.com/120x120.webp">
                          <source type="image/png" srcset="https://via.placeholder.com/120x120.png"><img src="https://via.placeholder.com/120x120.png" width="120" height="120" alt="Inicio de Sesion">
                        </picture>
                        <div class="mainVPTxt">
                          <div class="mainVPTitle"> 
                            <h2>Legalidad</h2>
                            <p class="fakeTitle">Legalidad</p>
                          </div>
                          <div class="mainVPInf">
                            <p>Estamos comprometidos con los más altos estándares éticos. Debemos actuar con honestidad e integridad en todo momento. </p>
                            <p>Conducirnos con integridad genera seguridad y confianza entre nosotros mismos y en las relaciones con nuestros clientes, proveedores y otros socios comerciales. También fomenta el respeto a nuestra organización y nos permite ser exitosos. </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="compPage cPage8 sct-bullets-item">
                      <div class="contMainVP">
                        <picture class="mainVPImg">
                          <source type="image/webp" srcset="https://via.placeholder.com/120x120.webp">
                          <source type="image/png" srcset="https://via.placeholder.com/120x120.png"><img src="https://via.placeholder.com/120x120.png" width="120" height="120" alt="Inicio de Sesion">
                        </picture>
                        <div class="mainVPTxt">
                          <div class="mainVPTitle"> 
                            <h2>Auesteridad</h2>
                            <p class="fakeTitle">Auesteridad</p>
                          </div>
                          <div class="mainVPInf">
                            <p>Estamos comprometidos con los más altos estándares éticos. Debemos actuar con honestidad e integridad en todo momento. </p>
                            <p>Conducirnos con integridad genera seguridad y confianza entre nosotros mismos y en las relaciones con nuestros clientes, proveedores y otros socios comerciales. También fomenta el respeto a nuestra organización y nos permite ser exitosos. </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="compPage cPage9 sct-bullets-item">
                      <div class="contMainVP">
                        <picture class="mainVPImg">
                          <source type="image/webp" srcset="https://via.placeholder.com/120x120.webp">
                          <source type="image/png" srcset="https://via.placeholder.com/120x120.png"><img src="https://via.placeholder.com/120x120.png" width="120" height="120" alt="Inicio de Sesion">
                        </picture>
                        <div class="mainVPTxt">
                          <div class="mainVPTitle"> 
                            <h2>Sustentabilidad</h2>
                            <p class="fakeTitle">Sustentabilidad</p>
                          </div>
                          <div class="mainVPInf">
                            <p>Estamos comprometidos con los más altos estándares éticos. Debemos actuar con honestidad e integridad en todo momento. </p>
                            <p>Conducirnos con integridad genera seguridad y confianza entre nosotros mismos y en las relaciones con nuestros clientes, proveedores y otros socios comerciales. También fomenta el respeto a nuestra organización y nos permite ser exitosos. </p>
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <div class="compTabNav">
                    <div class="compTabNavDots sct-bullets-content-tabs">
                      <label for="page" class="page sct-bullets-content-tabs-item">Honestidad</label>
                      <!-- <label for="page2" class="page2">Desarrollo Humano</label>
                      <label for="page3" class="page3">Respeto</label>
                      <label for="page4" class="page4">Creatividad Empresarial</label>
                      <label for="page5" class="page5">Productividad</label>
                      <label for="page6" class="page6">Optimismo y Actitud Positiva.</label>
                      <label for="page7" class="page7">Legalidad</label>
                      <label for="page8" class="page8">Auesteridad</label>
                      <label for="page9" class="page9">Sustentabilidad</label> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
    
          <section class="modMainCap sct-capacitate-empleo" >
            <style>
              .sct-capacitate-empleo .contMainCap:has(> #sctRegister) > .compPagination,
              .sct-capacitate-empleo .contMainCap:has(> .diligence.noPadBottom) > .compPagination {
                display: none !important;
              }
            </style>
            <div class="boxBg">
              <div class="oval-half1"></div>
              <div class="oval-half2"></div>
            </div>
            <div class="container">
              <div class="wrapperMainCap">
                <div class="sidebarCap">
                  <div class="sidebarCapInf">
                    <h1 class="sct-capacitate-empleo-title">Capacitate para el Empleo</h1>
                    <h2 class="sct-capacitate-empleo-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</h2>
                  </div>
                  <picture class="sidebarCapImg">
                    <img class="sct-capacitate-empleo-img" src="img/sidebarCapImg01.png" width="340" height="320" alt="Hombre con Laptop">
                  </picture>
                </div>
                <div class="contMainCap">
                  <div class="compPagination">
                    <div class="container sct-capacitate-empleo-container-page">
                      <input id="page1" type="radio" name="cpagination" checked="" class="pagRadio1">
                      <!-- <input id="page2" type="radio" name="cpagination" class="pagRadio2">
                      <input id="page3" type="radio" name="cpagination" class="pagRadio3">
                      <input id="page4" type="radio" name="cpagination" class="pagRadio4">
                      <input id="page5" type="radio" name="cpagination" class="pagRadio5"> -->
                      <div class="compPage cPage sct-capacitate-empleo-container-page-slider">
                          <div class="contFlexCap sct-capacitate-empleo-container-page-slider-content">
                            <div class="carCap sct-capacitate-empleo-container-page-slider-item">
                              <div class="carCapBody"> 
                                <h3 class="sct-capacitate-empleo-container-page-slider-item-title">Lorem Ipsum is simply dummy text.</h3>
                                <p class="sct-capacitate-empleo-container-page-slider-item-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>
                              </div>
                              <div class="carCapFooter">
                                <a href="#" class="btnIcon right sct-capacitate-empleo-container-page-slider-item-link" target="_blank"> <i class="ico-arrow-right-circle"></i>
                                  <span class="sct-capacitate-empleo-container-page-slider-item-btntxt">Conoce más</span>
                                </a>
                              </div>
                            </div>
                          </div>
                      </div>
                      <div class="compPagNav">
                        <!-- <div class="compPagNavArrow previous">
                          <label for="page1" class="numb1"></label>
                          <label for="page2" class="numb2"></label>
                          <label for="page3" class="numb3"></label>
                          <label for="page4" class="numb4"></label>
                          <label for="page5" class="numb5"></label>
                        </div> -->
                        <div class="compPagNavDots">
                          <label for="page1" class="page1"></label>
                          <!-- <label for="page2" class="page2"></label>
                          <label for="page3" class="page3"></label>
                          <label for="page4" class="page4"></label>
                          <label for="page5" class="page5"></label> -->
                        </div>
                        <!-- <div class="compPagNavArrow next">
                          <label for="page1" class="numb1"></label>
                          <label for="page2" class="numb2"></label>
                          <label for="page3" class="numb3"></label>
                          <label for="page4" class="numb4"></label>
                          <label for="page5" class="numb5"></label>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="sct-documents">
            <div id="" class="filterDocumentsId"></div>
            <div th:replace="fragments/fragments :: documents"></div>
          </section>

          <section class="modTabs sct-tabs-descripcion">
            <input id="tab1" type="radio" name="mtab" checked="" class="tabInput1">
            <div class="modTabsMenu container">
              <div class="container">
                <div class="modTabsMenuLabels sct-tabs-descripcion-content-tabs">
                  <label for="tab1" class="tabBtn1 sct-tabs-descripcion-content-tabs-item"><strong>Resposabilidades de Oficialia de Cumplimiento</strong></label>
                </div>
              </div>
            </div>
            <div class="modTabContent tabCont1 sct-tabs-descripcion-item">
              <div class="imgBG">
                <picture>
                  <img class="sct-tabs-descripcion-item-img" src="" width="1440" height="700" alt="">
                </picture>
              </div>
              <div class="container">
                <div class="oficiliaTabCont sct-tabs-descripcion-item-data-title">
                  <h3 class="sct-tabs-descripcion-item-subtitle">Algunas de las responsabilidades de la Oficialía de Cumplimiento son:</h3>
                  <div class="sct-tabs-descripcion-item-description">
                    <ul>
                      <li>Mantener actualizados los protocolos, políticas y estándares de integridad.</li>
                      <li>Diseñar e implementar los sistemas de control, vigilancia y auditorías con los   que contamos. </li>
                      <li>Elaborar, revisar y actualizar el Programa de Integridad y Cumplimiento. </li>
                      <li>Administrar, investigar y dar seguimiento a las quejas y denuncias presentadas a través de la Línea de Denuncia</li>
                      <li>Presidir los Comités de Ética Corporativo y de Subsidiarias, en donde se analizan y resuelven la procedencia o no de las denuncias, así como las posibles sanciones o acciones de mejora que resulten aplicables.</li>
                      <li>Diseñar los sistemas y procesos de entrenamiento y capacitación en materia de inegridad y ética.</li>
                      <li>Monitorear cualquier modificación al marco legal o regulatorio que impacte las políticas de la empresa.</li>
                      <li>Atender y resolver cualquier asunto relacionado con la integridad y ética empresarial.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
    
        </main>
        <footer>
          <div class="container">
            <div class="footerMain">
              <div class="footerCol">
                <h3><a href="#">Como Operamos</a></h3>
                <ul>
                  <li><a href="#">Comites</a></li>
                  <li><a href="#">Compliance Officers Subsidiarias</a></li>
                  <li><a href="#">Vigilancia y Auditorias</a></li>
                  <li><a href="#">Valores y Principios</a></li>
                </ul>
              </div>
              <div class="footerCol">
                <h3><a href="#">Documentos de Cumplimiento</a></h3>
                <ul>
                  <li><a href="#">Documentos</a></li>
                  <li><a href="#">Formularios y Procesos</a></li>
                  <li><a href="#">Status de Procesos</a></li>
                </ul>
              </div>
              <div class="footerCol">
                <h3><a href="#">Capacitate para el Empleo</a></h3>
                <ul>
                  <li><a href="#">Cursos</a></li>
                </ul>
              </div>
              <div class="footerCol">
                <h3><a href="#">Comunicación</a></h3>
                <ul>
                  <li><a href="#">Comunicación</a></li>
                </ul>
              </div>
            </div>
            <div class="footerBottom"><span>© 2021 Compliance AMX. Todos los derechos reservados.</span>
              <div class="fBottonRight">
                <ul>
                  <li><a href="#">Condiciones de Uso</a></li>
                  <li><a href="#">Aviso de privacidad</a></li>
                  <li><a href="#">Ayuda</a></li>
                </ul>
                <div class="fBottomLang"><i class="ico-globe"></i><span>México / Español</span></div>
              </div>
            </div>
          </div>
        </footer>
    
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css" type="text/css">
        <script src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js" type="text/javascript"></script>
        <script>
        $('.homeDocsSliderCarousel').slick({autoplay: true,autoplaySpeed: 5000,speed: 1000,slidesToShow: 3,slidesToScroll: 1,dots: false,responsive:[{breakpoint: 1200,settings:{slidesToShow: 2}},{breakpoint: 860,settings:{slidesToShow: 1}},{breakpoint: 640,settings:{slidesToShow: 1,arrows: false}}]})
        $('.homeSitesSlider').slick({
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 1000,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          variableWidth: true,
          dots: false,
        });
        </script>
        <style type="text/css">
          .homeDocsSliderCarousel { height: fit-content;; }
        </style>
      </body>
    </html>`
  },
  {
    id: 3,
    name: "Layout con etiquetas fragments (thymeleaf) Secciones",
    templete: `<!DOCTYPE html>
      <html xmlns:th="http://www.thymeleaf.org">
      <head lang="es" xml:lang="es">
      <meta charset="utf-8">
      <title></title>
      <th:block th:insert="~{fragments/fragments :: head}"></th:block>
      </head>
      <body>
        <header th:replace="~{fragments/fragments :: header}"></header>
        <main class="wrapper wfix dynamic-elements-content"></main>
        <footer th:replace="~{fragments/fragments :: footer}"></footer>
        <!-- Slick Slider-->
        <script th:src="@{/script/slick1.8.1.js}"></script>
        <link rel="stylesheet" type="text/css" th:href="@{/css/slick1.8.1.css}">
        <script th:src="@{/script/index.js}"></script>
        <script>
          $('.homeSitesSlider').slick({
            autoplay : true,
            autoplaySpeed : 5000,
            speed : 1000,
            slidesToShow : 3,
            slidesToScroll : 1,
            centerMode : true,
            variableWidth : true,
            dots : false,
          });
        </script>
        <script th:src="@{/script/ultimosDocumentos/ultimosDocumentos.js}" type="module"></script>
      </body>
      </html>
    `
  },
  {
    id: 4,
    name: "Layout final para el merge del nuevo contenido para Emails",
    templete: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
    <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
      <head>
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/>
        <title>AMX Compliance | Bienvenido al Portal de Cumplimiento de América móvil</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"/><!--[if !mso]><!-->
        <meta http-equiv="X-UA-Compatible" content="IE=edge"/><!--<![endif]-->
        <!--[if !mso]><!-->
        <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet"/><!--<![endif]-->
      </head>
      <body bgcolor="#f5f5f5" style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 16px; color: #3c3c3c; margin: 0; padding: 0; min-width: 100% !important;"><!--[if mso]>
        <style>body, table, td, p, span, a{font-family: Arial, Helvetica, sans-serif !important;}</style><!--<![endif]-->
        <!--[if (mso)|(IE)]>
        <table width="600" align="center" cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, Helvetica, sans-serif;">
          <tbody>
            <tr>
              <td></td><![endif]-->
            <!--Insertar Codigo Generado--!>
      </body>
    </html>
    `
  },
  {
    id: 5,
    name: "Layout default para plantillas Email con liga",
    templete: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
    <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
      <head>
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/>
        <title>AMX Compliance | Proceso de Regalos, Gastos de Entretenimiento y Hospitalidad</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"/><!--[if !mso]><!-->
        <meta http-equiv="X-UA-Compatible" content="IE=edge"/><!--<![endif]-->
        <!--[if !mso]><!-->
        <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet"/><!--<![endif]-->
      </head>
      <body bgcolor="#f5f5f5" style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 16px; color: #3c3c3c; margin: 0; padding: 0; min-width: 100% !important;"><!--[if mso]>
        <style>body, table, td, p, span, a{font-family: Arial, Helvetica, sans-serif !important;}</style><!--<![endif]-->
        <!--[if (mso)|(IE)]>
        <table width="600" align="center" cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, Helvetica, sans-serif;">
          <tbody>
            <tr>
              <td></td><![endif]-->
              <table width="100%" bgcolor="#f5f5f5" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                <tr>
                  <td style="width: 100%; height: 30px" bgcolor="#243773"></td>
                </tr>
                <tr>
                  <td style="padding:10px 40px 10px;" bgcolor="#ffffff"><a href="#" target="_blank"><img src="https://www.complianceamx.com/img/email/logo-email.jpg" alt="AMX Compliance" width="79" height="70"/></a></td>
                </tr>
                <tr>
                  <td bgcolor="#ffffff" style="text-align: center; padding: 20px 0;"><img src="https://www.complianceamx.com/img/email/ico-email.png" width="60" height="60"/></td>
                </tr>
                <tr>
                  <td>
                    <table width="100%" bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                      <tr>
                        <td>&nbsp;</td>
                        <td width="440" bgcolor="#ffffff" style="padding: 10px 20px 20px;">
                          <p style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 24px; font-weight: 300; color: #243773; text-align: center; width: 100%; max-width: 440px; margin: 0 auto; padding: 0;">Proceso de Regalos, Gastos de Entretenimiento y Hospitalidad</p>
                        </td>
                        <td>&nbsp;</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style="height: 280px; vertical-align: top; background-color: #fff;">
                    <table width="100%" height="280px" bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                      <tr>
                        <td>&nbsp;</td>
                        <td width="480" bgcolor="#ffffff" style="padding: 0 20px 20px; vertical-align: top;">
                          <p style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 300; color: #3C3C3C; text-align: center; line-height: 1.6; width: 100%; max-width: 480px; margin: 0 auto 20px; padding: 0;">Hola, <strong>$nombreSolicitante</strong>.</p>
                          <p style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 300; color: #3C3C3C; text-align: center; line-height: 1.6; width: 100%; max-width: 480px; margin: 0 auto 20px; padding: 0;">La Solicitud de Regalos y Gastos de Entretenimiento est&aacute; en revisi&oacute;n.</p>
                          <p style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 300; color: #3C3C3C; text-align: center; line-height: 1.6; width: 100%; max-width: 480px; margin: 0 auto 20px; padding: 0;">Por favor accede al sitio de Cumplimiento para revisar el estado de la solicitud $folio o <a href="&#36;{enlacePortal}" style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; color: #29B6F1; text-decoration: underline;">haz clic aqu&iacute;</a> para ser redirigido autom&aacute;ticamente.</p>
                        </td>
                        <td>&nbsp;</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style="width: 100%; height: 6px" bgcolor="#495259"></td>
                </tr>
                <tr>
                  <td style="padding:20px;" bgcolor="#283140">
                    <p style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 10px; font-weight: 300; color: #ffffff; text-align: center; line-height: 1.6; width: 100%; margin: 0 auto; padding: 0;">Copyright &copy; 2021 Compliance AMX. Todos los derechos reservados. Condiciones de Uso, Privacidad.</p>
                  </td>
                </tr>
              </table>
            </tr>
          </tbody>
        </table>
      </body>
    </html>`,
  },
  {
    id: 6,
    name: "Layout default para plantillas Email con boton",
    templete: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
    <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
      <head>
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/>
        <title>AMX Compliance | Bienvenido al Portal de Cumplimiento de América móvil</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"/><!--[if !mso]><!-->
        <meta http-equiv="X-UA-Compatible" content="IE=edge"/><!--<![endif]-->
        <!--[if !mso]><!-->
        <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet"/><!--<![endif]-->
      </head>
      <body bgcolor="#f5f5f5" style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 16px; color: #3c3c3c; margin: 0; padding: 0; min-width: 100% !important;"><!--[if mso]>
        <style>body, table, td, p, span, a{font-family: Arial, Helvetica, sans-serif !important;}</style><!--<![endif]-->
        <!--[if (mso)|(IE)]>
        <table width="600" align="center" cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, Helvetica, sans-serif;">
          <tbody>
            <tr>
              <td></td><![endif]-->
              <table width="100%" bgcolor="#f5f5f5" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                <tr>
                  <td style="width: 100%; height: 30px" bgcolor="#243773"></td>
                </tr>
                <tr>
                  <td style="padding:10px 40px 10px;" bgcolor="#ffffff"><a href="#" target="_blank"><img src="https://www.complianceamx.com/img/email/logo-email.jpg" alt="AMX Compliance" width="79" height="70"/></a></td>
                </tr>
                <tr>
                  <td bgcolor="#ffffff" style="text-align: center; padding: 20px 0;"><img src="https://www.complianceamx.com/img/email/ico-user.png" width="60" height="60"/></td>
                </tr>
                <tr>
                  <td>
                    <table width="100%" bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                      <tr>
                        <td>&nbsp;</td>
                        <td width="440" bgcolor="#ffffff" style="padding: 10px 20px 20px;">
                          <p style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 24px; font-weight: 300; color: #243773; text-align: center; width: 100%; max-width: 440px; margin: 0 auto; padding: 0;">Bienvenido al Portal de Cumplimiento de Am&eacute;rica m&oacute;vil</p>
                        </td>
                        <td>&nbsp;</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style="height: 280px; vertical-align: top; background-color: #fff;">
                    <table width="100%" height="280px" bgcolor="#ffffff" border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto;">
                      <tr>
                        <td>&nbsp;</td>
                        <td width="480" bgcolor="#ffffff" style="padding: 0 20px 20px; vertical-align: top;">
                          <p style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 300; color: #3C3C3C; text-align: center; line-height: 1.6; width: 100%; max-width: 480px; margin: 0 auto 20px; padding: 0;">Hola, <strong>$nombre</strong></p>
                          <p style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 300; color: #3C3C3C; text-align: center; line-height: 1.6; width: 100%; max-width: 480px; margin: 0 auto 20px; padding: 0;">Te damos la bienvenida al Portal de cumplimiento. Te informamos que tu cuenta ha sido activada exitosamente y ahora puedes iniciar tu proceso de Debida Diligencia.</p>
                          <p style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 300; color: #3C3C3C; text-align: center; line-height: 1.6; width: 100%; max-width: 480px; margin: 0 auto 20px; padding: 0;">Para iniciar tu proceso por favor inicia sesi&oacute;n o haz clic en el bot&oacute;n para comenzar.</p>
                          <p style="text-align: center;"><a href="&#36;{enlacePortal}"><img src="https://www.complianceamx.com/img/email/btn-iniciar.png" width="220" height="40"/></a></p>
                        </td>
                        <td>&nbsp;</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style="width: 100%; height: 6px" bgcolor="#495259"></td>
                </tr>
                <tr>
                  <td style="padding:20px;" bgcolor="#283140">
                    <p style="font-family: 'Roboto', Helvetica, Arial, sans-serif; font-size: 10px; font-weight: 300; color: #ffffff; text-align: center; line-height: 1.6; width: 100%; margin: 0 auto; padding: 0;">Copyright &copy; 2021 Compliance AMX. Todos los derechos reservados. Condiciones de Uso, Privacidad.</p>
                  </td>
                </tr>
              </table>
            </tr>
          </tbody>
        </table>
      </body>
    </html>
    `
  },
  {
    id: 7,
    name: "Layout con etiquetas fragments (thymeleaf) Formularios digitales",
    templete: `<!DOCTYPE html>
      <html xmlns:th="http://www.thymeleaf.org">
      <head lang="es" xml:lang="es">
      <meta charset="utf-8">
      <title></title>
      <th:block th:include="fragments/procesos :: head"></th:block>
      </head>
      <body>
        <header th:replace="fragments/procesos :: header"></header>
        <main class="wrapper wfix dynamic-elements-content"></main>
        <footer th:replace="fragments/procesos :: footer"></footer>
      </body>
      </html>
    `
  },
  {
    id: 8,
    name: "Layout con etiquetas fragments (thymeleaf) Home Aliados",
    templete: `<!DOCTYPE html>
      <html xmlns:th="http://www.thymeleaf.org">
      <head lang="es" xml:lang="es">
      <meta charset="utf-8">
      <title></title>
      <th:block th:insert="~{fragments/fragments :: head}"></th:block>
      </head>
      <body>
        <header th:replace="~{fragments/fragments :: header}"></header>
        <main class="wrapper wfix dynamic-elements-content"></main>
        <footer th:replace="~{fragments/fragments :: footer}"></footer>
        <!-- Slick Slider-->
        <script th:src="@{/script/slick1.8.1.js}"></script>
        <link rel="stylesheet" type="text/css" th:href="@{/css/slick1.8.1.css}">

        <script th:src="@{/script/index.js}"></script>
        <script th:src="@{/script/code-ethics.js}" type="module"></script>

        <script>
          $('.homeSitesSlider').slick({
            autoplay : true,
            autoplaySpeed : 5000,
            speed : 1000,
            slidesToShow : 3,
            slidesToScroll : 1,
            centerMode : true,
            variableWidth : true,
            dots : false,
          });
        </script>
      </body>
      </html>
    `
  },
];
